module.exports = __webpack_public_path__ + "img/kr.c018f1e1.svg";